import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          height: '100vh', background: '#101522', color: '#f8f9ff', fontFamily: 'system-ui, sans-serif',
          padding: '40px', textAlign: 'center'
        }}>
          <h2 style={{ fontSize: '24px', marginBottom: '16px' }}>Något gick fel</h2>
          <p style={{ color: '#8993a8', marginBottom: '24px', maxWidth: '500px' }}>
            {this.state.error?.message || 'Ett oväntat fel inträffade.'}
          </p>
          <button onClick={() => { this.setState({ hasError: false }); window.location.reload(); }}
            style={{
              padding: '12px 28px', borderRadius: '999px', border: '1px solid rgba(255,255,255,0.28)',
              background: 'linear-gradient(135deg, #d8edff, #78baff)', color: '#10213b',
              fontWeight: 700, cursor: 'pointer', fontSize: '14px'
            }}>
            Ladda om
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
